import { AttributeConfig, StrapiID } from '@ca/common/types'
import { SelectedItem } from '@order/orderTypes'
import { Discountable } from '@order/utils/discounts/Discounts'
import { ImageProps } from 'expo-image'

export const OptionTier = {
  default: 'default',
  standard: 'standard',
  comfort: 'comfort',
  premium: 'premium',
  highend: 'highend',
  worldclass: 'worldclass',
} as const

export type OptionTier = (typeof OptionTier)[keyof typeof OptionTier]

export const OptionColor = {
  default: 'default',
  gray: 'gray',
  latte: 'latte',
  green: 'green',
  magenta: 'magenta',
  blue: 'blue',
  bronze: 'bronze',
  silver: 'silver',
  gold: 'gold',
} as const

export type OptionColor = (typeof OptionColor)[keyof typeof OptionColor]

export const TintingIntensity = {
  full: 'full',
  '85': '85',
  '75': '75',
  '75-35': '75-35',
  '10': '10',
} as const

// export type Pricing = (typeof Pricing)[keyof typeof Pricing]
// export type TintingColor = (typeof TintingColor)[keyof typeof TintingColor]
export type TintingIntensity = `${number}-${number}` | `${number}` | 'full'

export const OptionAttributes = {
  package: 'package',
  tinting: 'tinting',
  intensity: 'intensity',
} as const

// export const isValuePricing = (value?: string | null): value is Pricing => {
//   if (!value) return false
//   return value in Pricing
// }

export const isValueOptionColor = (
  value?: string | number | null
): value is OptionColor => {
  if (!value) return false
  return value in OptionColor
}

export const getOptionColorFromValue = (
  value?: string | null
): OptionColor | null => {
  if (!value) return null
  const normalizedValue = Object.values(OptionColor).find((color) =>
    value?.toLowerCase().includes(color.toLowerCase())
  )
  if (normalizedValue) {
    return normalizedValue as OptionColor
  }
  return null
}

export type OptionAttribute =
  (typeof OptionAttributes)[keyof typeof OptionAttributes]

export type StepVariable = string | OptionAttribute

export interface StepOption {
  id: string | number
  variantId?: string | number
  stepVariable?: string | null
  value?: string | null
  title: string
  desc?: string | null
  lookup?: string[]
  label?: string | null
  priceValue?: string | null
  stepDesc?: string
  image?: string | null
  imageProps?: ImageProps | null
  name?: string
  pricing?: string // TODO: get this value from configuration context instead?
  price?: Discountable
  pricePrefix?: string | null
  priceSuffix?: string | null
  priceDisplayOnly?: boolean
  recommended?: boolean | null | undefined
  large?: boolean
  colorOption?: OptionColor
  colors?: StrapiID[]
  onPress?: () => void
  nextStep?: StrapiID | null
  select?: SelectedItem
  cta?: string | null
  magicGlow?: boolean
  attributes?: AttributeConfig[]
}

export type StepOptions = StepOption[]

export type StepAnswer = {
  id: StrapiID
  name: string
  title: string
  desc?: string | null
  image?: string | null
  onPress?: () => void
}
